import styled from '@emotion/styled';

export const Wrapper = styled.span`
  display: flex;
  align-items: flex-start;
  color: ${({ color }) => color || '#0B2374'};
  line-height: 32px;
`;

export const CurrencySign = styled.span`
  font-size: 12px;
  font-weight: 700;
  align-self: center;
  margin-right: 2px;
`;

export const Dollars = styled.span`
  font-weight: 700;
  font-size: 24px;
`;

export const Cents = styled.span`
  font-size: 12px;
  font-weight: 700;
  align-self: flex-start;
  line-height: 1;
  margin-top: 6px;
`;
